import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SharedService } from './services/shared.service';
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private sharedService: SharedService) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    setTimeout(() => {
        this.sharedService.setLoader(true);
    }, 1);
    return next.handle(request).pipe(
      finalize(() => {
        setTimeout(() => {
            this.sharedService.setLoader(false);
        }, 1);
      })
    );
  }
}

